import { useProductDescription } from '../hooks/useProductDescription';

type ProductDescriptionContainerProps = { children: React.ReactNode };

const ProductDescriptionContainer = ({ children }: ProductDescriptionContainerProps) => {
	const { blockClass, componentId } = useProductDescription();
	console.log(blockClass);
	const renderClass = () => {
		return (
			blockClass &&
			`productDescriptionContainer--${blockClass} vtex-store-components-3-x-productDescriptionContainer--${blockClass}`
		);
	};

	return (
		<div
			data-selection={componentId}
			className={`productDescriptionContainer vtex-store-components-3-x-productDescriptionContainer ${renderClass()}`}
		>
			{children}
		</div>
	);
};

export default ProductDescriptionContainer;
